module.exports = __webpack_public_path__ + "img/tabicon_5.b5d63447.png";